'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CalendarWarning = require('./CalendarWarning');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CalendarWarning).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CalendarWarning/index.js
// module id = 1130
// module chunks = 1